import {BaseModel} from '../base.model';

export class AuthModel extends BaseModel {

	token: string;
	dossier: string;
	id: number;
	uid: string;

	constructor() {
		super();
	}

}
